import { ProposalProduct } from '@trnsact/trnsact-shared-types/src/generated';

export const getProductFactHashMapKey = (product: ProposalProduct): string =>
  product.aftermarketProduct?.aftermarketProductId || product.proposalProductId;
